import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
import {
  RiArrowDropDownLine,
  RiArrowDropRightLine,
  RiMenu3Line,
  RiCloseLine,
  RiDashboard3Line,
} from "react-icons/ri";
import images from "../../constant/images";
import "./nav.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector } from "react-redux";
import { storeToken, updateLang } from "../../formSlice";
import { useDispatch } from "react-redux";
import { BiUser } from "react-icons/bi";
import { IoMdArrowDropright } from "react-icons/io";
import { FiLogOut } from "react-icons/fi";
import { MdOutlineEventAvailable, MdOutlineGroups } from "react-icons/md";
import { LuHandshake } from "react-icons/lu";
import { AiOutlineCreditCard } from "react-icons/ai";
import { IoNotificationsOutline } from "react-icons/io5";
import { BsDash } from "react-icons/bs";
import RolexClock from "../rolex/RolexClock";

export const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const language = localStorage.getItem("i18nextLng");

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (dropdownId) => {
    setOpenDropdown(openDropdown === dropdownId ? null : dropdownId);
  };
  // import { RiArrowDropDownLine, RiArrowDropRightLine } from "react-icons/ri";

  // export const Nav = () => {
  const local = useLocation();
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
    dispatch(updateLang(lng));
  };

  const activePaths = [
    "/GTMclub/2025Program",
    "/GTMclub/tournois/gtmIconic",
    "/GTMclub/tournois/industry",
    "/GTMclub/strategies/2daySummit",
    "/GTMclub/Golf&LinkingUp",
    "/GTMclub/business/cultures",
  ];
  const isActive = activePaths.includes(location.pathname);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [openApropos, setOpenApropos] = useState(false);
  const [openGtmClub, setOpenGtmClub] = useState(false);
  const [openBusiness, setOpenBusiness] = useState(false);
  const [openTournois, setOpenTournois] = useState(false);
  const [openActualites, setOpenActualites] = useState(false);
  const [openMedia, setOpenMedia] = useState(false);
  const [openRanking, setOpenRanking] = useState(false);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [user, setUser] = useState();
  const [membership, setMembership] = useState(null);
  const profile = useSelector((state) => state.gtm.profile);
  const [pack, setPack] = useState(null);
  const [error, setError] = useState(null);
  const [membresh, setMembresh] = useState(false);
  const [pages, setPages] = useState([]);
  const lang = useSelector((state) => state.gtm.lang);

  const localStorageUser = localStorage.getItem("user");
  const token = localStorage.getItem("userToken");
  const [isLoading, setIsLoading] = useState(true);
  const fetchData = async () => {
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
        setMembership(response.data?.membership);

        if (response.data?.membership?.status.trim() === "valid") {
          setPack(response.data.membership?.membership_packs);
        }
        dispatch(storeToken(token));
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const platform = "web";

        const response = await axios.get(`${baseUrl}/pages`, {
          params: {
            lang: lang,
            platform: platform,
          },
        });

        setPages(response.data.pages);
      } catch (error) {
        console.error("Error fetching pages:", error);
      }
    };

    fetchPages();
  }, [lang]);

  // Toggle functions:
  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen);
    document.body.classList.toggle("no-scroll", !mobileOpen);
  };

  const toggleGtmClub = () => {
    setOpenGtmClub(!openGtmClub);
  };
  const toggleMembreship = () => {
    setMembresh(!membresh);
  };

  const toggleActualites = () => {
    setOpenActualites(!openActualites);
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const getimages = (packType) => {
    if (packType) {
      return membership?.membership_packs?.profile;
    }

    if (user?.free_pack === 1) {
      return images.Frame;
    }

    return images.visiteur;
  };
  const imagess = getimages(membership?.membership_packs?.profile);
  const getimages2 = (packType) => {
    const normalizedPack = String(packType).toLowerCase().trim();

    const imagesMap = {
      "non-golfer": images.bronze_menu,
      golfer: images.gold_menu,
      "golfer+": images.platinum_menu,
      default: images.menu_visit,
    };

    return imagesMap[normalizedPack] || imagesMap.default;
  };
  const imagess2 = getimages2(membership?.membership_packs?.name);

  const getimages3 = (packType) => {
    const normalizedPack = String(packType).toLowerCase().trim();

    const imagesMap = {
      "non-golfer": images.bronz,
      golfer: images.goldd,
      "golfer+": images.platin,
      default: images.logo,
    };

    return imagesMap[normalizedPack] || imagesMap.default;
  };
  const imagess3 = getimages3(membership?.membership_packs?.name);

  const packGradients = {
    "non-golfer": {
      colors: ["#441903", "#FF6F3F", "#FFA47F", "#CA5730", "#442525"],
      locations: [0, 0.25, 0.5, 0.75, 1.0],
    },
    golfer: {
      colors: [
        "#884F00",
        "#8E5709",
        "#9D6B21",
        "#B68C49",
        "#D8BA80",
        "#FFEFBF",
        "#DDC28D",
        "#C19C62",
        "#A97C3F",
        "#976423",
        "#895210",
        "#824704",
        "#7F4400",
      ],
      locations: [
        0.01, 0.06, 0.15, 0.25, 0.38, 0.51, 0.58, 0.65, 0.72, 0.79, 0.86, 0.93,
        1.0,
      ],
    },
    "golfer+": {
      colors: [
        "#5C5C5C",
        "#6C6C6C",
        "#A5A5A5",
        "#BCBCBC",
        "#D6D6D6",
        "#C1C1C1",
        "#8A8A8A",
        "#474747",
      ],
      locations: [0, 0.02, 0.11, 0.15, 0.49, 0.53, 0.79, 1.0],
    },
    default: {
      colors: ["#00573f", "#00573f"],
      locations: [0, 0.5],
    },
  };

  const getimagess2 = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.color}`;
    }

    return "#00573f";
  };
  const imagess22 = getimagess2(membership?.membership_packs?.color);

  function getGradientStyle(pack) {
    const gradientConfig = packGradients[pack] || packGradients.default;

    const colorStops = gradientConfig.colors
      ?.map(
        (color, index) => `${color} ${gradientConfig.locations[index] * 100}%`
      )
      .join(", ");

    return `linear-gradient(90deg, ${colorStops})`;
  }

  const logout = async () => {
    const token = localStorage.getItem("userToken");

    if (!token) {
      return navigate("/login");
    }

    try {
      await axios.post(
        `${baseUrl}/logout`,
        {
          withCredentials: true,
          withXSRFToken: true,
          credentials: "include",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");

      dispatch(storeToken(null));

      navigate("/login");
    }
  };

  // const getHoverClass = (packType) => {
  //   const normalizedPack = String(packType).toLowerCase().trim();

  //   const hoverClasses = {
  //     "non-golfer": "hover:text-[#FF6F3F] group-hover:text-[#FF6F3F]",
  //     golfer: "hover:text-[#884F00] group-hover:text-[#884F00]",
  //     "golfer+": "hover:text-[#5C5C5C] group-hover:text-[#5C5C5C]",
  //     "defafree membershipult":
  //       "hover:text-[#00573f] group-hover:text-[#00573f]",
  //     default: "hover:text-[#fff] group-hover:text-[#fff]",
  //   };

  //   return hoverClasses[normalizedPack] || hoverClasses.default;
  // };
  // const hoverClass = getHoverClass(membership?.membership_packs?.name);

  const getimagess = (packType) => {
    if (packType) {
      return `${membership?.membership_packs?.bars}`;
    }

    return images.menu_visit;
  };
  const imagesMenu = getimagess(membership?.membership_packs?.bars);

  const sidebarRef = useRef(null);

  const bodyRef = useRef(document.body);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeSidebar();
      }
    };

    if (mobileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      bodyRef.current.style.overflow = "hidden";
    } else {
      bodyRef.current.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      bodyRef.current.style.overflow = "auto";
    };
  }, [mobileOpen]);

  const closeSidebar = () => {
    setMobileOpen(false);
    bodyRef.current.style.overflow = "auto";
  };

  const isActive2 = (path) => local.pathname === path;
  const [hoveredItem, setHoveredItem] = useState(null);
  const handleHover = (itemId) => {
    setHoveredItem(itemId);
  };

  const handleHoverLeave = () => {
    setHoveredItem(null);
  };

  return (
    <nav className=" flex flex-col gap-2">
      <div className="flex items-center block custom:hidden  justify-between p-4 text-white bg-black">
        {/* logo */}
        <NavLink href="/home" className="block custom:hidden z-50">
          <img
            className="w-[60px] h-[70px] overflow-visible"
            src={images.gtm_rolex}
            alt="Logo GTM"
          />
        </NavLink>

        <button className="menu-btn custom:hidden " onClick={toggleMobileMenu}>
          {mobileOpen ? (
            <RiCloseLine
              size={28}
              style={{
                color: membership?.membership_packs?.color,
              }}
            />
          ) : (
            <img src={imagesMenu} width={40} className="" alt="" />
          )}
        </button>
      </div>
      <div className=" px-[5rem] custom4:px-[6rem] screen  hidden custom:block">
        <div className="flex flex-col items-center gap-2 ">
          <div className="flex items-end justify-between">
            <ul className="nav  flex items-center h-[75px] justify-center gap-8 pe-6 text-white relative">
              <li className="flex items-center justify-center">
                <NavLink to="/home">
                  <img
                    className=" overflow-visible"
                    width={90}
                    src={images.gtm_rolex}
                    alt="Logo GTM"
                  />
                </NavLink>
              </li>
              <div className="flex gap-[3.7rem] z-[99999]">
                <li
                  className={`hover  text-[1rem] relative ${
                    isActive ? "active" : ""
                  }`}
                >
                  <div className="group">
                    <NavLink
                      to="#"
                      type="button"
                      className={`flex items-center  justify-center whitespace-nowrap hover_miss ${
                        location.pathname === "/GTMclub/2025Program" ||
                        location.pathname === "/GTMclub/calendar" ||
                        location.pathname === "/GTMclub/tournois/gtmIconic" ||
                        location.pathname === "/GTMclub/tournois/industry" ||
                        location.pathname === "/GTMclub/tournois/Initiation" ||
                        location.pathname === "/gtmclub/tournois/longsDrive" ||
                        location.pathname === "/GTMclub/Golf&LinkingUp" ||
                        location.pathname === "/networking/moroccanSun" ||
                        location.pathname === "/GTMclub/business/cultures" ||
                        location.pathname ===
                          "/GTMclub/strategies/2daySummit" ||
                        location.pathname === "/lifestyle/arts" ||
                        location.pathname === "/lifestyle/bigsmoke" ||
                        location.pathname ===
                          "/gtmclub/2025program/show_events" ||
                        location.pathname === "/gtmclub/calendar/show_events" ||
                        location.pathname === "/lifestyle/classicCars"
                          ? " text-nav_gold"
                          : ""
                      }`}
                    >
                      {t("navbar.gtmClub")}
                      <div className="text-2xl transition-transform duration-300 hover-miss group-hover:rotate-180">
                        <RiArrowDropDownLine />
                      </div>
                    </NavLink>
                    <div className="absolute left-0 w-full h-6"></div>
                    <div className="absolute left-0 mt-6 w-60 origin-top-left bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                      <div className="">
                        <NavLink
                          to="/GTMclub/2025Program"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss ${
                            location.pathname === "/GTMclub/2025Program"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          {t("navbar.gtm_Club.programme")}
                        </NavLink>
                        <NavLink
                          to="/GTMclub/calendar"
                          className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss ${
                            location.pathname === "/GTMclub/calendar"
                              ? "text-nav_gold font-bold"
                              : ""
                          }`}
                        >
                          2025 National Golf Events
                        </NavLink>

                        <div className="relative group/Networking">
                          <NavLink
                            to="/GTMclub/Golf&LinkingUp"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                              location.pathname === "/GTMclub/Golf&LinkingUp" ||
                              location.pathname === "/networking/moroccanSun" ||
                              location.pathname ===
                                "/GTMclub/business/cultures" ||
                              location.pathname ===
                                "/GTMclub/strategies/2daySummit"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Business
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-0 w-full h-5"></div>
                          <div className="absolute left-[100%] top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Networking:opacity-100 group-hover/Networking:visible transition duration-300">
                            <NavLink
                              to="/networking/conference"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname === "/networking/conference"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {/* {t("navbar.gtm_Club.busines_sub.g_n")} */}
                              Conferences
                            </NavLink>
                            <NavLink
                              to="/networking/moroccanSun"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname === "/networking/moroccanSun"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {/* {t("navbar.gtm_Club.busines_sub.g_n")} */}
                              Moroccan Sunset
                            </NavLink>
                            <NavLink
                              to="/GTMclub/business/cultures"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname ===
                                "/GTMclub/business/cultures"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {t("navbar.gtm_Club.busines_sub.b_c")}
                            </NavLink>
                            <NavLink
                              to="/GTMclub/strategies/2daySummit"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname ===
                                "/GTMclub/strategies/2daySummit"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {t("navbar.gtm_Club.summit_sub.day_summit")}
                            </NavLink>
                          </div>
                        </div>

                        <div className="relative group/tournois">
                          <NavLink
                            to="#"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                              location.pathname ===
                                "/GTMclub/tournois/gtmIconic" ||
                              location.pathname ===
                                "/GTMclub/tournois/industry" ||
                              location.pathname ===
                                "/GTMclub/tournois/Initiation" ||
                              location.pathname ===
                                "/gtmclub/tournois/longsDrive"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            Golf
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/tournois:opacity-100 group-hover/tournois:visible transition duration-300">
                            <NavLink
                              to="/GTMclub/tournois/Initiation"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname ===
                                "/GTMclub/tournois/Initiation"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              Initiation
                            </NavLink>
                            <NavLink
                              to="/GTMclub/tournois/gtmIconic"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname ===
                                "/GTMclub/tournois/gtmIconic"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {t("navbar.gtm_Club.tournaments_sub.gtm_ionic")}
                            </NavLink>
                            <NavLink
                              to="/gtmclub/tournois/longsDrive"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname ===
                                "/gtmclub/tournois/longsDrive"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              Longest Drive
                            </NavLink>
                            <NavLink
                              to="/GTMclub/tournois/industry"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss ${
                                location.pathname ===
                                "/GTMclub/tournois/industry"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {t("navbar.gtm_Club.tournaments_sub.industry")}
                            </NavLink>
                          </div>
                        </div>

                        <div className="relative group/Strategies">
                          <NavLink
                            to="#"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                              location.pathname === "/lifestyle/arts" ||
                              location.pathname === "/lifestyle/bigsmoke" ||
                              location.pathname === "/lifestyle/classicCars"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {/* {t("navbar.gtm_Club.summit")} */}
                            Lifestyle
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Strategies:opacity-100 group-hover/Strategies:visible transition duration-300">
                            <NavLink
                              to="/lifestyle/arts"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname === "/lifestyle/arts"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                              Art
                            </NavLink>
                            <NavLink
                              to="/lifestyle/bigsmoke"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname === "/lifestyle/bigsmoke"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                              Big Smoke
                            </NavLink>
                            <NavLink
                              to="/lifestyle/classicCars"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname === "/lifestyle/classicCars"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                              Classic Cars
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`hover lin  text-[1rem] pr-3 whitespace-nowrap hover_miss ${
                    location.pathname === "/membership/welcome" ||
                    location.pathname === "/membership/profile" ||
                    location.pathname === "/membership/welcometwo" ||
                    location.pathname === "/membership/demande" ||
                    location.pathname === "/membership/thanks" ||
                    location.pathname === "/membership/Partners" ||
                    location.pathname === "/membership/Events" ||
                    location.pathname === "/membership/show_events" ||
                    location.pathname === "/membership/notification" ||
                    location.pathname === "/membership/show-notification" ||
                    location.pathname === "/membership/members" ||
                    location.pathname === "/membership/paimentInfo" ||
                    location.pathname === "/membership/paiments" ||
                    location.pathname === "/membership/Testimonials" ||
                    location.pathname === "/membership/Contact"
                      ? "text-nav_gold font-bold"
                      : ""
                  }`}
                >
                  <NavLink
                    to="/membership/welcome"
                    // className={`${
                    //       location.pathname === "/membership/welcome"
                    //         ? " text-nav_gold"
                    //         : ""
                    //     }`}
                  >
                    {t("navbar.membership")}
                  </NavLink>
                </li>

                <li
                  className={`hover lin text-[1rem] relative ${
                    location.pathname === "/actualites/ranking" ||
                    location.pathname === "/actualites/media/presse" ||
                    location.pathname === "/actualites/media/blog"
                      ? "text-nav_gold font-bold"
                      : ""
                  }`}
                >
                  <div className="group">
                    <button
                      type="button"
                      className="flex items-center justify-center whitespace-nowrap hover_miss"
                    >
                      {t("navbar.news")}
                      <div className="text-2xl transition-transform duration-300 group-hover:rotate-180">
                        <RiArrowDropDownLine />
                      </div>
                    </button>
                    <div className="absolute left-0 w-full h-6"></div>
                    <div className="absolute left-0 mt-6 w-56 origin-top-left bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                      <div className="">
                        <div className="relative group/tournois">
                          <NavLink
                            to="/actualites/ranking"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                              location.pathname === "/actualites/ranking"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.news_sub.ranking")}
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/tournois:opacity-100 group-hover/tournois:visible transition duration-300">
                            <NavLink
                              to="/actualites/ranking#Iconique"
                              className="block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-gray-300 hover_miss"
                            >
                              {t("navbar.news_sub.ranking_sub.iconic")}
                            </NavLink>
                            <NavLink
                              to="/actualites/ranking#Holes18"
                              className="block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss"
                            >
                              {t("navbar.news_sub.ranking_sub.18_holes")}
                            </NavLink>
                            <NavLink
                              to="/actualites/ranking#Holes9"
                              className="block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss"
                            >
                              {t("navbar.news_sub.ranking_sub.9_holes")}
                            </NavLink>
                          </div>
                        </div>

                        <div className="relative group/Strategies">
                          <NavLink
                            to="#"
                            className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                              location.pathname ===
                                "/actualites/media/presse" ||
                              location.pathname === "/actualites/media/blog"
                                ? "text-nav_gold font-bold"
                                : ""
                            }`}
                          >
                            {t("navbar.news_sub.media")}
                            <RiArrowDropRightLine className="text-lg" />
                          </NavLink>
                          <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/Strategies:opacity-100 group-hover/Strategies:visible transition duration-300">
                            <div className="relative group/presse">
                              <NavLink
                                to="/actualites/media/presse"
                                className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 flex justify-between items-center hover_miss ${
                                  location.pathname ===
                                  "/actualites/media/presse"
                                    ? "text-nav_gold font-bold"
                                    : ""
                                }`}
                              >
                                {t("navbar.news_sub.media_sub.press")}
                                <RiArrowDropRightLine className="text-lg" />
                              </NavLink>
                              <div className="absolute left-full top-0 w-48 bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover/presse:opacity-100 group-hover/presse:visible transition duration-300">
                                <NavLink
                                  to="/actualites/media/presse#Written"
                                  className="block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss"
                                >
                                  {t(
                                    "navbar.news_sub.media_sub.press_sub.written"
                                  )}
                                </NavLink>
                                <NavLink
                                  to="/actualites/media/presse#Audiovisual"
                                  className="block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss"
                                >
                                  {t(
                                    "navbar.news_sub.media_sub.press_sub.audio"
                                  )}
                                </NavLink>
                              </div>
                            </div>
                            <NavLink
                              to="/actualites/media/blog"
                              className={`block px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                                location.pathname === "/actualites/media/blog"
                                  ? "text-nav_gold font-bold"
                                  : ""
                              }`}
                            >
                              {t("navbar.news_sub.media_sub.blog")}
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  className={`hover lin text-[1rem] relative whitespace-nowrap hover_miss ${
                    location.pathname === "/sponsoring"
                      ? "text-nav_gold font-bold"
                      : ""
                  }`}
                >
                  <NavLink to="/sponsoring">{t("navbar.sponsoring")}</NavLink>
                </li>

                <li
                  className={`hover lin text-[1rem] relative ${
                    location.pathname === "/apropos" ||
                    location.pathname === "/apropos/gallery"
                      ? "text-nav_gold font-bold"
                      : ""
                  }`}
                >
                  <div className="group">
                    <button
                      type="button"
                      className="flex items-center justify-center "
                    >
                      <NavLink
                        to="/apropos"
                        className="whitespace-nowrap hover_miss"
                      >
                        {t("navbar.aboutUs")}
                      </NavLink>
                      <div className="text-2xl transition-transform duration-300 group-hover:rotate-180">
                        <RiArrowDropDownLine />
                      </div>
                    </button>
                    <div className="absolute left-0 w-full h-6"></div>
                    <div className="absolute left-0 mt-6 w-56 origin-top-left bg-white divide-y divide-gray-100 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                      <div className="">
                        <NavLink
                          to="/apropos#Fondateur"
                          className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss"
                        >
                          {t("navbar.about_Us.founder")}
                        </NavLink>
                        <NavLink
                          to="/apropos#Mission"
                          className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss"
                        >
                          {t("navbar.about_Us.mission")}
                        </NavLink>
                        <NavLink
                          to="/apropos#Temoignages"
                          className="block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 border-b-2 border-gray-300 hover_miss"
                        >
                          {t("navbar.about_Us.testimonials")}
                        </NavLink>
                        {/* <a
                    href="/apropos/gallery"
                    className={`block whitespace-nowrap px-4 py-4 text-sm text-gray-700 hover:bg-gray-100 hover_miss ${
                      location.pathname === "/apropos/gallery"
                        ? "text-nav_gold font-bold"
                        : ""
                    }`}
                  >
                    Gallery
                  </a> */}
                      </div>
                    </div>
                  </div>
                </li>
              </div>
              {/* <li
            className={`hover lin text-[1rem] relative whitespace-nowrap ${
              location.pathname === "/login" ? "active" : ""
            }`}
          >
            <a href="/login"> {t("navbar.login")}</a>
          </li> */}
              {/* <li
            className={`hover lin text-[1rem] relative whitespace-nowrap ${
              location.pathname === "/register" ||
              location.pathname === "/register/stepTwo" ||
              location.pathname === "/register/stepThree" ||
              location.pathname === "/register/verification" ||
              location.pathname === "/register/confirmation"
                ? "active"
                : ""
            }`}
          >
            <a href="/register"> {t("navbar.register")}</a>
          </li> */}
              {/* <li
            className={`hover lin text-[1rem] pr-3 whitespace-nowrap ${
              local.pathname === "/contactus" ? "active" : ""
            }`}
          >
            {" "}
            <a href="/contactus">{t("navbar.contact_us")}</a>{" "}
          </li> */}
            </ul>
            {/* <iframe
              data-v-2b84e7e6=""
              allowfullscreen="allowfullscreen"
              scrolling="NO"
              frameborder="NO"
              // class=""
              src="https://static.rolex.com/clocks/2018/ladieseuropeantour_desktop_HTML_270x90/rolex.html"
              // style="height: 90px; border: 0px; margin: 0px; padding: 0px; overflow: hidden;"
              className="embed-responsive-item rolex  rounded-xl h-[75px] shadow-[5px_3px_15px_rgba(0,0,0,0.4)]"
            ></iframe>  */}
            <div className="flex flex-col items-end gap-2">
              <div className="flex items-center justify-end gap-4  pb-3 pt-4">
                <p
                  className="flex items-center gap-1 cursor-pointer hover:opacity-50"
                  onClick={() => changeLanguage("fr")}
                >
                  <img width={20} src={images.france_logo} alt="" />
                  <span
                    className="text-white font-semibold"
                    style={{
                      textShadow: "2px 0px 5px #000",
                      fontWeight: "700",
                    }}
                  >
                    Francais
                  </span>
                </p>
                <p
                  className="flex items-center gap-1 cursor-pointer hover:opacity-50"
                  onClick={() => changeLanguage("en")}
                >
                  <img width={20} src={images.usa_logo} alt="" />
                  <span
                    className="text-white font-semibold"
                    style={{
                      textShadow: "2px 0px 5px #000",
                      fontWeight: "700",
                    }}
                  >
                    English
                  </span>
                </p>
                {!localStorageUser ? (
                  <div>
                    <NavLink to="/login">
                      <button className="font-bold hover:opacity-75 text-white bg-[#00573f] px-10 py-1 text-[18px] rounded-full">
                        Login
                      </button>
                    </NavLink>
                  </div>
                ) : (
                  <div>
                    <NavLink to="/membership/profile">
                      <button className="font-bold flex  gap-2 items-center text-[#00573f] bg-white border border-[#00573f] px-6 py-1 text-[18px] rounded-full">
                        <BiUser
                          className={`h-6 w-6 text-[#00573f] font-bold   `}
                        />

                        {language === "fr" ? "Mon profil" : "My profile"}
                      </button>
                    </NavLink>
                  </div>
                )}
              </div>
              <RolexClock style=" max-w-[25vw] shadow-[5px_3px_15px_rgba(0,0,0,0.4)] rounded-full h-[75px]" />
            </div>
          </div>
        </div>
      </div>

      {/* mobile menu */}
      <div
        className={`mobile-menu overflow-x-hidden custom:hidden ${
          mobileOpen ? "open" : ""
        }`}
      >
        <ul className="mobile-nav-links" ref={sidebarRef}>
          <li className="flex items-center justify-center mt-4">
            {user ? (
              <div className="flex op relative flex-col items-center gap-1 mt-4 mb-4">
                <div className="relative">
                  <img src={imagess} alt="" className="h-[98px]  w-[160px]" />
                  <img
                    src={profile ?? user?.photo}
                    alt=""
                    className="h-[98px] w-[100px] rounded-full absolute bottom-[4px] left-1/2 transform -translate-x-1/2"
                  />
                </div>

                <div className="flex flex-col items-center gap-[1rem]">
                  <p
                    className=" text-[20px] font-bold "
                    style={{
                      color: membership?.membership_packs?.color ?? "#00573f",
                    }}
                  >
                    {pack
                      ? pack?.name?.charAt(0).toUpperCase() +
                        pack?.name?.slice(1)
                      : "Free"}{" "}
                    <span className="text-[15px] text-white">
                      {t("sideBar.member2")}
                    </span>
                  </p>

                  {pack?.id !== 3 && (
                    <button
                      onClick={() => navigate("/membership/demande")}
                      className={`font-bold px-6 py-2 md:px-8 md:py-3 rounded-full text-sm md:text-base ${
                        membership?.membership_packs?.name === "golfer" ||
                        membership?.membership_packs?.name === "golfer+"
                          ? "text-black"
                          : " text-white"
                      }`}
                      style={{
                        backgroundColor: imagess22,
                      }}
                    >
                      Upgrade
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <NavLink to="/home">
                <img
                  className="w-[60px] h-[70px] overflow-visible"
                  src={images.gtm_rolex}
                  alt="Logo GTM"
                />
              </NavLink>
            )}
          </li>

          <li>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleGtmClub}
            >
              {t("navbar.gtmClub")}
              <RiArrowDropDownLine className="inline-block text-2xl" />
            </button>
            {openGtmClub && (
              <ul className="submenu">
                <li>
                  <NavLink to="/GTMclub/2025Program">
                    {t("navbar.gtm_Club.programme")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/GTMclub/calendar">
                    2025 National Golf Events
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/GTMclub/Golf&LinkingUp">
                    <button className="flex items-center justify-between w-full">
                      Business
                      <RiArrowDropDownLine className="inline-block text-2xl" />
                    </button>
                  </NavLink>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/networking/conference">
                        {/* {t("navbar.gtm_Club.busines_sub.g_n")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Conferences
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/networking/moroccanSun">
                        {/* {t("navbar.gtm_Club.busines_sub.g_n")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Moroccan Sunset
                        </div>
                      </NavLink>
                    </li>
                    {/* <li>
                      <a href="/GTMclub/business/cultures">
                        {t("navbar.gtm_Club.busines_sub.b_c")}
                      </a>
                    </li> */}
                    <li>
                      <NavLink to="/GTMclub/business/cultures">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.busines_sub.b_c")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/GTMclub/strategies/2daySummit">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.summit_sub.day_summit")}
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <button type="button" className="dropdown-toggle">
                    {/* {t("navbar.gtm_Club.tournaments_sub.industry")} */}
                    Golf
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/GTMclub/tournois/Initiation">
                        {/* {t("navbar.gtm_Club.tournaments_sub.industry")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Initiation
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/GTMclub/tournois/gtmIconic"
                        className="flex"
                      >
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.tournaments_sub.gtm_ionic")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/gtmclub/tournois/longsDrive"
                        className="flex"
                      >
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Longest Drive
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/GTMclub/tournois/industry">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.gtm_Club.tournaments_sub.industry")}
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li>
                  <button type="button" className="dropdown-toggle">
                    {/* {t("navbar.gtm_Club.summit")} */}
                    Lifestyle
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/lifestyle/arts">
                        {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Art
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/lifestyle/bigsmoke">
                        {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Big Smoke
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/lifestyle/classicCars">
                        {/* {t("navbar.gtm_Club.summit_sub.day_summit")} */}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          Classic Cars
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </li>

          {/* <li>
            <a href="/membership/welcome">{t("navbar.membership")}</a>
          </li> */}

          <li>
            {!user ? (
              <Link to="/membership/welcome" className="dropdown-toggle">
                {t("navbar.membership")}
              </Link>
            ) : (
              <button
                type="button"
                className="dropdown-toggle"
                onClick={toggleMembreship}
              >
                {t("navbar.membership")}
                <RiArrowDropDownLine className="inline-block text-2xl" />
              </button>
            )}
            {membresh && (
              <ul className="submenu">
                {user && (
                  <>
                    <li>
                      <NavLink to="/membership/welcome">
                        <div
                          className={`flex items-center justify-start font-bold gap-2 cursor-pointer  `}
                          style={{
                            color:
                              isActive2("/membership/welcome") ||
                              hoveredItem === "dashboard"
                                ? membership?.membership_packs?.color
                                : "#fff",
                          }}
                          onMouseEnter={() => handleHover("dashboard")}
                          onMouseLeave={handleHoverLeave}
                        >
                          <RiDashboard3Line
                            className={`h-6 w-6 text-white   `}
                            style={{
                              color:
                                isActive2("/membership/welcome") ||
                                hoveredItem === "dashboard"
                                  ? membership?.membership_packs?.color
                                  : "#fff",
                            }}
                            onMouseEnter={() => handleHover("dashboard")}
                            onMouseLeave={handleHoverLeave}
                          />
                          {t("sideBar.dashboard")}
                        </div>
                      </NavLink>
                    </li>
                    {user?.membership &&
                      user?.membership?.membership_id === 3 && (
                        <li>
                          <NavLink to="/membership/members">
                            <div
                              className={`flex items-center justify-start font-bold gap-2 cursor-pointer  `}
                              style={{
                                color:
                                  isActive2("/membership/members") ||
                                  hoveredItem === "members"
                                    ? membership?.membership_packs?.color
                                    : "#fff",
                              }}
                              onMouseEnter={() => handleHover("members")}
                              onMouseLeave={handleHoverLeave}
                            >
                              <MdOutlineGroups
                                className={`h-6 w-6 text-white   `}
                                style={{
                                  color:
                                    isActive2("/membership/members") ||
                                    hoveredItem === "members"
                                      ? membership?.membership_packs?.color
                                      : "#fff",
                                }}
                                onMouseEnter={() => handleHover("members")}
                                onMouseLeave={handleHoverLeave}
                              />
                              Members
                            </div>
                          </NavLink>
                        </li>
                      )}

                    <li>
                      <button
                        className=""
                        onClick={() =>
                          navigate("/membership/paiments", {
                            state: {
                              userId: user?.id,
                            },
                          })
                        }
                      >
                        <div
                          className={`flex items-center text-white px-4 py-3 justify-start  font-bold gap-2 cursor-pointer   `}
                          style={{
                            color:
                              isActive2("/membership/paiments") ||
                              hoveredItem === "paiments"
                                ? membership?.membership_packs?.color
                                : "#fff",
                          }}
                          onMouseEnter={() => handleHover("paiments")}
                          onMouseLeave={handleHoverLeave}
                        >
                          <AiOutlineCreditCard
                            className={`h-6 w-6 text-white  `}
                            style={{
                              color:
                                isActive2("/membership/paiments") ||
                                hoveredItem === "paiments"
                                  ? membership?.membership_packs?.color
                                  : "#fff",
                            }}
                            onMouseEnter={() => handleHover("paiments")}
                            onMouseLeave={handleHoverLeave}
                          />
                          {t("sideBar.payments")}
                        </div>
                      </button>
                    </li>

                    <li>
                      <button
                        onClick={() =>
                          navigate("/membership/notification", {
                            state: {
                              userId: user?.id, // Pass the user ID
                            },
                          })
                        }
                      >
                        <div
                          className={`flex items-center text-white px-4 py-3 justify-start  font-bold gap-2 cursor-pointer   `}
                          style={{
                            color:
                              isActive2("/membership/notification") ||
                              hoveredItem === "notification"
                                ? membership?.membership_packs?.color
                                : "#fff",
                          }}
                          onMouseEnter={() => handleHover("notification")}
                          onMouseLeave={handleHoverLeave}
                        >
                          <IoNotificationsOutline
                            className={`h-6 w-6 text-white  `}
                            style={{
                              color:
                                isActive2("/membership/notification") ||
                                hoveredItem === "notification"
                                  ? membership?.membership_packs?.color
                                  : "#fff",
                            }}
                            onMouseEnter={() => handleHover("notification")}
                            onMouseLeave={handleHoverLeave}
                          />
                          {t("sideBar.notifications")}
                        </div>
                      </button>
                    </li>

                    <li className="mt-[2rem] ">
                      {pages?.map((page) => {
                        return (
                          <div
                            key={page.id}
                            className={`flex items-center justify-start  font-bold gap-2 cursor-pointer  `}
                            style={{
                              color:
                                isActive2(`/membership/${page.route_name}`) ||
                                hoveredItem === page.name
                                  ? membership?.membership_packs?.color
                                  : "#fff",
                            }}
                            onMouseEnter={() => handleHover(page.name)}
                            onMouseLeave={handleHoverLeave}
                          >
                            <BsDash
                              className={`h-6 w-6 text-gray-900 `}
                              style={{
                                color:
                                  isActive2(`/membership/${page.route_name}`) ||
                                  hoveredItem === page.name
                                    ? membership?.membership_packs?.color
                                    : "#fff",
                              }}
                            />
                            <NavLink
                              to={`/membership/${page.route_name}`}
                              style={{
                                color:
                                  isActive2(`/membership/${page.route_name}`) ||
                                  hoveredItem === page.name
                                    ? membership?.membership_packs?.color
                                    : "#fff",
                              }}
                              onMouseEnter={() => handleHover(page.name)}
                              onMouseLeave={handleHoverLeave}
                            >
                              {page.name}
                            </NavLink>
                          </div>
                        );
                      })}
                    </li>
                  </>
                )}
              </ul>
            )}
          </li>

          <li>
            <NavLink to="/sponsoring">{t("navbar.sponsoring")}</NavLink>
          </li>

          <li>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleActualites}
            >
              {t("navbar.news")}
              <RiArrowDropDownLine className="inline-block text-2xl" />
            </button>
            {openActualites && (
              <ul className="submenu">
                <li>
                  <NavLink to="/actualites/ranking">
                    <button type="button" className="dropdown-toggle">
                      {t("navbar.news_sub.ranking")}
                      <RiArrowDropDownLine className="inline-block text-2xl" />
                    </button>
                  </NavLink>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/actualites/ranking#Iconique">
                        {" "}
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.news_sub.ranking_sub.iconic")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/actualites/ranking#Holes18">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.news_sub.ranking_sub.18_holes")}
                        </div>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/actualites/ranking#Holes9">
                        <div className="flex items-center gap-2">
                          <IoMdArrowDropright />
                          {t("navbar.news_sub.ranking_sub.9_holes")}
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <button type="button" className="dropdown-toggle">
                    {t("navbar.news_sub.media")}
                    <RiArrowDropDownLine className="inline-block text-2xl" />
                  </button>
                  <ul className="submenu nested">
                    <li>
                      <NavLink to="/actualites/media/presse">
                        <button type="button" className="dropdown-toggle">
                          {t("navbar.news_sub.media_sub.press")}
                          <RiArrowDropDownLine className="inline-block text-2xl" />
                        </button>
                      </NavLink>
                      <ul className="submenu nestedd">
                        <li>
                          <NavLink to="/actualites/media/presse#Written">
                            <div className="flex items-center gap-2">
                              <IoMdArrowDropright />
                              {t("navbar.news_sub.media_sub.press_sub.written")}
                            </div>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/actualites/media/presse#Audiovisual">
                            <div className="flex items-center gap-2">
                              <IoMdArrowDropright />
                              {t("navbar.news_sub.media_sub.press_sub.audio")}
                            </div>
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink to="/actualites/media/blog">
                        {t("navbar.news_sub.media_sub.blog")}
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            )}
          </li>

          <li>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={() => {
                setOpenApropos(!openApropos);
                // navigate("/apropos");
              }}
            >
              {t("navbar.aboutUs")}
              <RiArrowDropDownLine className="inline-block text-2xl" />
            </button>
            {openApropos && (
              <ul className="submenu">
                <li>
                  <NavLink to="/apropos#Fondateur">
                    {t("navbar.about_Us.founder")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/apropos#Mission">
                    {t("navbar.about_Us.mission")}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/apropos#Temoignages">
                    {t("navbar.about_Us.testimonials")}
                  </NavLink>
                </li>
                {/* <li>
                  <a href="/apropos/gallery">
                    Gallery
                  </a>
                </li> */}
              </ul>
            )}
          </li>
        </ul>
        <div className=" flex flex-col    gap-10 pr-[12rem] pb-3 pt-5 pl-4">
          <div className="flex items-center gap-10">
            <button
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => i18n.changeLanguage("fr")}
            >
              <img width={20} src={images.france_logo} alt="" />
              <span className="text-white font-semibold">Francais</span>
            </button>
            <button
              className="flex items-center gap-1 cursor-pointer hover:opacity-50"
              onClick={() => i18n.changeLanguage("en")}
            >
              <img width={20} src={images.usa_logo} alt="" />
              <span className="text-white font-semibold">English</span>
            </button>
          </div>
          <div>
            {!localStorageUser ? (
              <NavLink to="/login">
                <button className="font-bold text-white bg-[#00573f] px-10 py-1 text-[18px] rounded-full">
                  Login
                </button>
              </NavLink>
            ) : (
              <div>
                <div>
                  <NavLink to="/membership/profile">
                    <button className="font-bold flex  gap-2 items-center text-[#00573f] bg-white border border-[#00573f] px-10 py-2 text-[15px] rounded-full w-[12rem]">
                      <BiUser
                        className={`h-6 w-6 text-[#00573f] font-bold  `}
                      />
                      {t("sideBar.my_profile")}
                    </button>
                  </NavLink>
                </div>

                <div className="flex items-center justify-start mt-[2.5rem] text-white w-[20rem]  font-bold gap-2 cursor-pointer hover:text-[#ff0000] group">
                  <FiLogOut className="h-6 text-white w-6 group-hover:text-[#ff0000]" />
                  <button
                    className="text-white text-[15px] group-hover:text-[#ff0000]"
                    onClick={logout}
                  >
                    Se déconnecter
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
